// extracted by mini-css-extract-plugin
export default {"resumo-content":"styles_resumo-content__m-Hix","title":"styles_title__QjCAO","flex":"styles_flex__TbIFX","link-text":"styles_link-text__YEN1F"};